import React from "react";
import Chevron from "../../assets/chevron-right.svg";

const SliderNavButton = (
  {
    className = "",
    direction = "right",
  }
) => {
  return (
    <button
      className={`slider-nav-button ${className}`}
      type="button"
      aria-label="Slider Navigation"
    >
      <Chevron className={`slider-nav-button__icon slider-nav-button__icon--${direction}`} />
    </button>
  )
}

export default SliderNavButton
